<template>
  <div class="main" v-if="pageShow">
    <div class="title">为您精选以下 助贷服务平台</div>
    <div class="content" style="position: relative;"
         v-for="(item,index) in list" :key="index">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div style="width: 100%;">
          <div style="display: flex;">
            <div class="pIcon"><img :src="item.logo" alt="">
            </div>
            <div class="name">{{ item.productName }}</div>
          </div>

          <div class="line"></div>
          <div style="display: flex;">
            <div style="margin-right: 10px;color: #999;">服务公司</div>
            <div>{{ item.companyName }}</div>
          </div>
        </div>
        <div style="width: 40px;margin-left: 10px;" @click="item.selected=!item.selected">
          <div style="width: 25px;height:25px;" v-if="item.selected">
            <img style="width: 100%;height: auto;" src="@/assets/img/newpage/apply_selected.png">
          </div>
          <div style="width: 25px;height:25px;" v-else>
            <img style="width: 100%;height: auto;" src="@/assets/img/newpage/circle_no_selected.png">
          </div>
        </div>
      </div>
      <div style="position: absolute;top: 0px;right: 0px;width: 84px;">
        <img style="width: 100%;height: auto;" src="@/assets/img/newpage/normal_agency_tip.png">
      </div>
    </div>

    <div class="agree">
      <div style="background: #FBFBFB;">
        <AgreementForeign style="padding: 0rem;" :productName="productName" :realName="realName"
                          :idCard="idCard"
                          :date="date" :uid="customerId"></AgreementForeign>
      </div>
    </div>
    <div class="bottomDesc">
      本次借款服务由"{{ productName }}"提供，本平台仅提供信息展示，不参与任何放款行为，请仔细阅读相关协议
    </div>
    <div class="xieyi" style="margin-top: 0.05rem;" v-if="protocolList && protocolList.length>0">
      <div class="check"
           v-if="xySelect" @click="xySelect=!xySelect">
        <img src="@/assets/img/newpage/circle_selected.png" style="width: 100%;height: 100%;">
      </div>
      <div class="check" v-else
           @click="xySelect=!xySelect">
        <img src="@/assets/img/newpage/circle_no_selected.png" style="width: 100%;height: 100%;">
      </div>
      <div class="txt">
        <span>我以阅读并同意</span>
        <span v-for="(item,index) in protocolList" :key="index" @click="goXy(item.link)">《{{ item.title }}》</span>
      </div>
    </div>
    <div class="btn" v-if="btnShow" @click="submit"><span>同意协议并确认申请</span></div>

    <Loading :isShow="loading"></Loading>
  </div>
</template>

<script>
import Loading from '@/components/loading';
import AgreementForeign from '@/views/loan/agreementForeign';

export default {
  name: "applyResultForeign",
  components: {
    Loading,
    AgreementForeign
  },
  data() {
    return {
      pageShow: false,
      loading: false,
      recordId: 0,
      xySelect: false, //选择协议
      list: [],

      productName: "",
      realName: "",
      idCard: "",
      date: "",
      customerId: 0,
      partnerId: 0,
      protocolList: [],
    }
  }, created() {
    this.util.title('初审通过');
    var customerId = this.$route.query.customerId;
    if (customerId) {
      this.customerId = customerId;
    }
    var partnerId = this.$route.query.partnerId;
    if (partnerId) {
      this.partnerId = partnerId;
    }
    var recordId = this.$route.query.recordId;
    if (recordId) {
      this.recordId = recordId;
    }
    let json = {
      event_key: 'h5_landpage_apiload_view',
      customer_id: this.customerId,
      partner_id: this.partnerId
    }
    this.toCountPoint(json)
    this.getAgencyInfo();
  }, computed: {
    btnShow() {
      var list = this.list.filter(e => e.selected);
      if (list.length > 0) {
        return true;
      }
      return false;
    },
  }, methods: {
    //统计埋点
    toCountPoint(json) {
      this.$get('/app/api/v1/newEventTrace', json)
          .then(res => {
            if (res.code == 200) {
            } else {
              this.util.toast({msg: res.message})
            }
          })
          .catch(error => {
          });
    },
    getAgencyInfo() {
      let param = {
        customerId: this.customerId,
        recordId: this.recordId
      }
      this.loading = true;
      this.$get("/app/api/v1/foreign/getAgencyList", param).then((res) => {
        if (res.code == 200) {
          this.pageShow = true;
          this.loading = false;
          var data = res.data;
          this.productName = data.allProductName;
          this.realName = data.realName;
          this.idCard = data.idCard;
          this.date = data.date;
          var agencyList = data.agencyList;
          var protocolList = []
          var pIds = []
          agencyList.forEach(e => {
            e.selected = true;
            if (e.protocolList && e.protocolList.length > 0) {
              protocolList.push(...e.protocolList)
            }
            pIds.push(e.productId);
          })
          this.list = agencyList;
          this.protocolList = protocolList;

          let json = {
            event_key: 'h5_landpage_apichannel_view',
            customer_id: this.customerId,
            partner_id: this.partnerId,
            product_id: pIds.join(',')
          }
          this.toCountPoint(json)
        } else {
          this.loading = false;
          this.util.toast({msg: res.message});
        }
      });
    },
    submit() {
      /*if (!this.xySelect) {
        this.util.toast({msg: "请先勾选协议"})
        return;
      }*/
      this.xySelect = true;
      console.log(this.list)
      let newList = this.list.filter(item => item.selected);
      if (newList.length <= 0) {
        this.util.toast({msg: "至少选择一家机构"});
        return;
      }
      var agencyCityId = 0;
      var productIds = [];
      newList.forEach(e => {
        productIds.push(e.productId);
        if (e.agencyCityId > 0) {
          agencyCityId = e.agencyCityId;
        }
      })
      var productIdStr = productIds.join(',');
      let params = {
        customerId: this.customerId,
        recordId: this.recordId,
        productIds: productIdStr,
        agencyCityId: agencyCityId
      };
      let json = {
        event_key: 'h5_landpage_apichannel_click',
        customer_id: this.customerId,
        partner_id: this.partnerId,
        product_id: productIdStr
      }
      this.toCountPoint(json)
      this.postOrder(params);
    }, async postOrder(params) {
      console.log("成单前的参数:====")
      console.log(params)
      this.loading = true;
      await this.$post("/app/api/v1/foreign/agency/postOrder", params)
          .then((res) => {
            if (res.code == 200) {
              this.loading = false;
              window.location.href = res.data;
            } else {
              this.loading = false;
              this.util.toast({msg: res.message})
            }
          });
    }, goXy(url) {
      window.location.href = url;
    }

  }
}
</script>

<style scoped>
* {
  margin: 0rem;
  padding: 0rem;
}

img {
  width: 100%;
  height: 100%;
}

.main {
  width: 100%;
  background: url('../../assets/img/afterLoan/applyResult_bj.png') no-repeat;
  background-size: cover;
  padding: 0.2rem 0.15rem;
}

.main .title {
  font-size: 0.2rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  text-align: center;
}

.main .desc {
  font-size: 0.2rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}

.main .content {
  margin: 0.1rem 0rem;
  background: #FFFFFF;
  padding: 0.2rem 0.15rem;
  border-radius: 0.1rem;
}

.main .content .pIcon {
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.1rem;
}

.main .content .name {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.main .content .tip {
  font-size: 0.08rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FB6600;
  background: #FFEAC1;
  border-radius: 0.05rem;
  margin-left: 0.05rem;
  height: 0.16rem;
  line-height: 0.14rem;
  padding: 1px 4px;
  margin-top: 3px;
}

.main .content .line {
  width: 100%;
  height: 1px;
  background: #C7C7C7;
  opacity: 0.28;
  margin: 0.1rem auto;
}


.main .content .info {
  display: flex;
  justify-content: space-between;
}

.main .content .info .key {
  font-size: 0.18rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.main .content .info .value {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.main .agree {
  height: 3.5rem;
  margin: 0.1rem 0rem;
  background: #FFFFFF;
  padding: 0.15rem;
  border-radius: 0.1rem;
  overflow-y: scroll;
}

.main .agree .title {
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
  margin-bottom: 0.1rem;
}

.main .agree .text {
  font-size: 0.1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.2rem;
}

.main .btn {
  width: 100%;
  height: 0.5rem;
  text-align: center;
  line-height: 0.5rem;
  background: linear-gradient(45deg, #2566FD 0%, #4FAAFE 100%);
  border-radius: 0.25rem;
  margin: 0.1rem auto 0.15rem;
}

.main .btn span {
  font-size: 0.16rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #fff;
}


.xieyi {
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
  margin-left: 0.1rem;

  font-size: 0.12rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.xieyi .check {
  width: 0.14rem;
  height: 0.14rem;
  margin-right: 0.05rem;
}

.footer {
  margin-top: 0.1rem;
  text-align: center;
  font-size: 0.1rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.16rem;
}

.pSelected {
  width: 0.25rem;
  height: 0.25rem;
}

.bottomDesc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 10px;
  color: #666666;
  line-height: 16px;
  font-style: normal;
}

</style>
